import type { JSX } from 'react'
import type { IAuthFormBoxProps } from '../AuthFormBox'

import { AuthFormBox } from '../AuthFormBox'
import {
  AuthFormBoxAlignItems,
  AuthFormBoxPaddings,
  AuthFormBoxRowGaps,
} from '../AuthFormBox.h'

export interface IAuthFormBoxInternalTemplateProps extends IAuthFormBoxProps {}

export const AuthFormBoxInternalTemplate = ({
  children,
  width = 348,
  padding = AuthFormBoxPaddings.SIZE_0,
  rowGap = AuthFormBoxRowGaps.SIZE_150,
  alignItems = AuthFormBoxAlignItems.FlexStart,
  ...rest
}: IAuthFormBoxInternalTemplateProps): JSX.Element => (
  <AuthFormBox
    width={width}
    padding={padding}
    rowGap={rowGap}
    alignItems={alignItems}
    {...rest}
  >
    {children}
  </AuthFormBox>
)

AuthFormBoxInternalTemplate.displayName = 'AuthFormBoxInternalTemplate'
